import { getDefaultBetslipPurchaseType } from '@app/utils/config/sportConfig';
import { EMPTY_PAYOUT } from '@core/models/betSlip/Payout';

import { createActions } from './actions';
import { createGetters } from './getters';
import { mutations } from './mutations';
import { BetSlipState } from './types';
import { BetSlipType } from '@core/models/shared/betSlip/betSlipEnums';
interface LocalParams {
    initialState?: Partial<BetSlipState>;
    getDefaultStake: () => number;
    getMultiMarketSelectEnabledFlag: () => Promise<boolean>;
}
type Params = Omit<Parameters<typeof createActions>[0], 'betSlipInstancesCount'>
    & Parameters<typeof createGetters>[0]
    & LocalParams;

export function createBetSlipModule({
    subscribeToEvent,
    getEvents,
    initialState = {},
    getPayout,
    getDefaultStake,
    getMatch,
    calculateNetStake,
    getUser,
    maxSystemsCount,
    getMultiMarketSelectEnabledFlag,
    roundToTwoDecimals,
}: Params) {
    const state: BetSlipState = {
        autoUpdateChanges: true,
        changes: {},
        errors: [],
        selectionAddError: null,
        selectionErrors: {},
        purchaseType: getDefaultBetslipPurchaseType(),
        payout: EMPTY_PAYOUT,
        payoutLocked: false,
        warning: null,
        bonusError: null,
        selections: [],
        stake: null,
        type: BetSlipType.simple,
        betSlipErrors: {
            sportValidation: [],
            bonusValidation: null,
        },
        selectedSystems: [],
        ...initialState,
        bonusWarning: null,
        isBonusSelected: true,
        isRecreatingTicket: false,
        isSubmittingOdd: {},
    };

    return {
        state,
        mutations,
        actions: createActions({
            subscribeToEvent,
            getEvents,
            getPayout,
            getDefaultStake,
            getMatch,
            getUser,
            roundToTwoDecimals,
            maxSystemsCount,
            getMultiMarketSelectEnabledFlag,
        }),
        getters: createGetters({
            calculateNetStake,
        }),
        namespaced: true,
    };
}

export type BetslipStore = ReturnType<typeof createBetSlipModule>;
